import app from './app.ts';
import { FStorage } from '~common/firebase/storage.ts';

class KintFStorage extends FStorage {}

export const kintFStorage = new KintFStorage(app);
export default kintFStorage;
